/* ==========================================================================
   Profit Minded: scratch-off SMS pop-up (NGS 2026-10-26)

   Flow:  trigger (delay / desktop exit intent) -> drag a finger across the silver
          foil (or tap "Scratch it for me", or press Space/Enter on the foil) ->
          once enough is cleared the foil fades and the prize shows. EVERY ticket
          wins the same prize. -> "Claim it" -> window.postscript.popups.open(popupId).
          Postscript owns the phone step, consent and the code. If its SDK is
          missing (blocked/failed), Claim is a real <a href> to the fallback link.

   Lifecycle (once per visitor, cooldown after a dismiss, reopen tab, Postscript
   subscriber skip, scroll lock, the Postscript hold, the non-modal Claim bridge)
   is ported from Bom Blast (assets/bom-blast.js on bom-bom.co, verified live).
   Every tunable is a data-pms-* attribute written by snippets/pm-scratch.liquid
   from Theme settings > Scratch-off pop-up. No libraries.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-pm-scratch]');
  if (!root || typeof root.showModal !== 'function') return;

  function num(v, d) { var n = parseFloat(v); return isNaN(n) ? d : n; }
  function attr(n) { return (root.getAttribute('data-pms-' + n) || '').trim(); }
  var cfg = {
    enabled:      attr('enabled') === 'true',
    popupId:      attr('popup-id'),
    fallbackUrl:  attr('fallback-url'),
    delay:        num(attr('delay'), 6),
    exitIntent:   attr('exit-intent') === 'true',
    cooldownDays: num(attr('cooldown-days'), 7),
    force:        /[?&]pm_scratch=1\b/.test(location.search)
  };
  // Auto-open only once it is switched on AND Claim has somewhere to go.
  var ready = cfg.enabled && !!(cfg.popupId || cfg.fallbackUrl);

  var KEY = 'pm_scratch_v1';
  function readState() { try { return JSON.parse(localStorage.getItem(KEY) || 'null') || {}; } catch (e) { return {}; } }
  function writeState(patch) {
    try { var s = readState(); for (var k in patch) s[k] = patch[k]; localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {}
  }
  function emit(action, extra) {
    var d = { action: action }; if (extra) for (var k in extra) d[k] = extra[k];
    try { document.dispatchEvent(new CustomEvent('pm:scratch', { detail: d })); } catch (e) {}
  }

  var reduceMotion = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer  = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---------------------------------------------------------------- gating */

  function fromOurTexts() { return /utm_source=postscript/i.test(location.search); }
  function suppressedLocally() {
    if (cfg.force) return false;
    if (!ready || fromOurTexts()) return true;
    var s = readState();
    if (s.claimed) return true;
    if (s.dismissed && Date.now() - s.dismissed < cfg.cooldownDays * 864e5) return true;
    return false;
  }
  // getSubscriberId may be sync or a promise depending on the SDK build.
  function isSubscriber(cb) {
    var ps = window.postscript, r;
    if (!ps || typeof ps.getSubscriberId !== 'function') return cb(false);
    try { r = ps.getSubscriberId(); } catch (e) { return cb(false); }
    if (r && typeof r.then === 'function') {
      var done = false;
      r.then(function (id) { if (!done) { done = true; cb(!!id); } }, function () { if (!done) { done = true; cb(false); } });
      setTimeout(function () { if (!done) { done = true; cb(false); } }, 1500);
    } else cb(!!r);
  }
  /* --------------------------------------------------- Postscript hold: Postscript's screen must not show until the shopper
     taps Claim. While the game is in play, Postscript's frame is kept invisible and click-through (html.pm-ps-hold, set in
     <head> by snippets/pm-scratch-hold.liquid before Postscript loads) and its scroll lock is cancelled, even if its own
     trigger fires. Claim releases it. Only while not claimed. */
  var holding = document.documentElement.classList.contains('pm-ps-hold');
  function holdPostscript() { if (!holding) { holding = true; document.documentElement.classList.add('pm-ps-hold'); } }
  function releaseHold() { holding = false; document.documentElement.classList.remove('pm-ps-hold'); }

  // Never stack on the cart drawer, the search panel, another dialog or someone else's pop-up.
  function visible(el) { var r = el.getBoundingClientRect(); return r.width > 200 && r.height > 200 && getComputedStyle(el).visibility !== 'hidden'; }
  function somethingElseOpen() {
    var open = document.querySelectorAll('dialog[open]');
    for (var i = 0; i < open.length; i++) if (open[i] !== root) return true;
    if (document.querySelector('[data-pm-drawer][data-open="true"]')) return true;           // PM's cart drawer (pm-cart.js)
    var modals = document.querySelectorAll('[aria-modal="true"]:not([aria-hidden="true"])');  // e.g. a Klaviyo form
    for (var j = 0; j < modals.length; j++) if (modals[j] !== root && !root.contains(modals[j]) && visible(modals[j])) return true;
    // Postscript's own pop-up, when it is actually visible (while we hold it, it is hidden and does not count)
    var ps = document.getElementById('ps__widget');
    if (ps && !holding && visible(ps)) return true;
    return false;
  }

  var shown = false, timer = null;
  // Exactly one open per page: the delay timer and desktop exit intent can both fire, and the subscriber check is async,
  // so the first trigger claims the slot before checking.
  // Only open when Claim can deliver the code: Postscript's pop-up API is loaded (ad blockers stop it) or a fallback link is set.
  // Postscript loads after the page, so wait for it up to 10 s. A ?pm_scratch=1 preview always opens.
  function psReady() { var ps = window.postscript; return !!(ps && ps.popups && typeof ps.popups.open === 'function'); }
  function canClaim() { return cfg.force || !!cfg.fallbackUrl || psReady(); }
  function whenClaimable(cb) {
    var t0 = Date.now();
    (function poll() { if (canClaim()) return cb(true); if (Date.now() - t0 > 10000) return cb(false); setTimeout(poll, 250); })();
  }
  function tryOpen() {
    if (shown) return;
    if (somethingElseOpen()) { timer = setTimeout(tryOpen, 4000); return; }
    shown = true; clearTimeout(timer); document.removeEventListener('mouseout', onExit);
    whenClaimable(function (ok) { if (ok) isSubscriber(function (sub) { if (sub && !cfg.force) return; open(); }); });
  }
  function onExit(e) {
    if (e.relatedTarget == null && e.clientY <= 0) {
      document.removeEventListener('mouseout', onExit);
      clearTimeout(timer); tryOpen();
    }
  }
  function arm() {
    // A preview link (?pm_scratch=1) always starts from scratch, so the whole flow can be reviewed again.
    if (cfg.force) { try { localStorage.removeItem(KEY); } catch (e) {} }
    var s = readState();
    if ((ready || cfg.force) && cfg.popupId && !s.claimed && !fromOurTexts()) holdPostscript();
    if (!cfg.force && s.claimed) return;
    if (tabWanted(s)) showTab(true);
    if (suppressedLocally()) return;
    setTimeout(warm, Math.max(0, cfg.delay - 3) * 1000);   // fetch the logo just before it can open
    if (cfg.delay >= 0) timer = setTimeout(tryOpen, (cfg.force ? Math.min(cfg.delay, 1) : cfg.delay) * 1000);
    if (cfg.exitIntent && finePointer) document.addEventListener('mouseout', onExit);
  }

  /* --------------------------------------------------------------- elements */

  var foil    = root.querySelector('[data-pms-foil]');
  var coins   = root.querySelector('[data-pms-coins]');
  var autoBtn = root.querySelector('[data-pms-auto]');
  var claimEl = root.querySelector('[data-pms-claim]');
  var live    = root.querySelector('[data-pms-live]');
  var won = false, claimed = false;

  var keyboardUser = false;   // move focus to Claim only for keyboard users: no stray focus ring on touch
  root.addEventListener('keydown', function () { keyboardUser = true; }, true);
  root.addEventListener('pointerdown', function () { keyboardUser = false; }, true);

  function setStep(s) { root.setAttribute('data-pms-step', s); }

  var warmed = false;
  function warm() {
    if (warmed) return; warmed = true;
    Array.prototype.forEach.call(root.querySelectorAll('img[data-src]'), function (img) {
      img.src = img.getAttribute('data-src'); img.removeAttribute('data-src');
    });
  }

  /* ------------------------------------------------------ scroll lock (html)
     showModal() traps focus but the page behind still scrolls on iOS; lock <html>
     (not <body>) and give the scrollbar's width back so nothing shifts. */
  var lockPad = '';
  function lockScroll() {
    var de = document.documentElement, sb = window.innerWidth - de.clientWidth;
    lockPad = de.style.paddingRight; de.classList.add('pm-scratch-lock');
    if (sb > 0) de.style.paddingRight = sb + 'px';
  }
  function unlockScroll() { var de = document.documentElement; de.classList.remove('pm-scratch-lock'); de.style.paddingRight = lockPad; }

  /* ------------------------------------------------------------ open/close */
  var opening = false;
  function artReady(cb) {
    var img = root.querySelector('.pms-logo'), done = false, finish = function () { if (!done) { done = true; cb(); } };
    setTimeout(finish, 1200);
    if (!img) return finish();
    if (img.decode) img.decode().then(finish, finish);
    else if (img.complete) finish(); else img.onload = img.onerror = finish;
  }
  function open() {
    if (root.open || opening) return;                              // never twice
    if (!canClaim()) { hideTab(); return; }                       // Postscript blocked: no way to text the code
    opening = true; shown = true; clearTimeout(timer);
    document.removeEventListener('mouseout', onExit);
    hideTab(); warm();
    artReady(function () { opening = false; if (!root.open) reveal(); });
  }
  function reveal() {
    // Something else opened while we waited on Postscript / the subscriber check / the artwork (e.g. the homepage
    // hero's sign-up pop-up, 2026-11-02): step back and retry instead of opening on top of it and stealing focus.
    if (somethingElseOpen()) { shown = false; timer = setTimeout(tryOpen, 4000); return; }
    if (readState().won && !won) { won = true; if (foil) foil.classList.add('is-gone'); }   // a returning winner: straight to the prize
    setStep(won ? 'won' : 'ready');
    root.showModal(); lockScroll();
    root.focus({ preventScroll: true });
    writeState({ shown: Date.now() });
    if (!won) requestAnimationFrame(paintFoil);
    emit('open', { won: won });
  }
  root.addEventListener('close', function () {
    unlockScroll();
    if (!claimed) { writeState({ dismissed: Date.now() }); emit('dismiss', { won: won }); showTab(false); }
  });
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-pms-close]')) return root.close();
    // the backdrop: a click on the dialog element itself, outside its box (a scratch released past the edge is not a dismiss)
    if (e.target === root && Date.now() - lastScratch > 400) {
      var r = root.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) root.close();
    }
  });
  window.addEventListener('resize', function () { if (root.open && !won && !scratched) paintFoil(); });

  /* ------------------------------------------------------------- the foil
     A canvas over the prize, painted silver and scratched away with destination-out. The prize counts as revealed once
     ~42% is cleared (checked every few moves), or ~30% when the finger lifts. */
  var ctx = null, W = 0, H = 0, dpr = 1, moves = 0, scratched = false, last = null, lastScratch = 0;
  function paintFoil() {
    if (!foil) return;
    var r = foil.getBoundingClientRect(); dpr = Math.min(2, window.devicePixelRatio || 1);
    W = Math.round(r.width * dpr); H = Math.round(r.height * dpr);
    if (!W || !H) return;
    foil.width = W; foil.height = H; ctx = foil.getContext('2d');
    var g = ctx.createLinearGradient(0, 0, W, H);
    g.addColorStop(0, '#e9ecf0'); g.addColorStop(.45, '#b8bfc8'); g.addColorStop(.55, '#d5dae0'); g.addColorStop(1, '#9aa2ad');
    ctx.globalCompositeOperation = 'source-over'; ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
    ctx.fillStyle = 'rgba(255,255,255,.35)'; for (var i = 0; i < 260; i++) ctx.fillRect(Math.random() * W, Math.random() * H, dpr, dpr);
    ctx.fillStyle = 'rgba(40,50,64,.55)'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
    ctx.font = '700 ' + Math.round(15 * dpr) + 'px Arial'; ctx.fillText('SCRATCH HERE', W / 2, H / 2 - 10 * dpr);
    ctx.font = '700 ' + Math.round(10 * dpr) + 'px Arial'; ctx.fillText('$  $  $  $  $', W / 2, H / 2 + 12 * dpr);
    foil.classList.remove('is-gone'); moves = 0; scratched = false;
  }
  function scratchAt(x, y) {
    if (!ctx || won) return;
    scratched = true; lastScratch = Date.now();
    ctx.globalCompositeOperation = 'destination-out'; ctx.beginPath(); ctx.arc(x * dpr, y * dpr, 22 * dpr, 0, Math.PI * 2); ctx.fill();
    if (++moves % 8 === 0 && cleared() > .42) win();
  }
  function line(a, b) {
    var d = Math.hypot(b.x - a.x, b.y - a.y), n = Math.max(1, Math.ceil(d / 8));
    for (var i = 1; i <= n; i++) scratchAt(a.x + (b.x - a.x) * i / n, a.y + (b.y - a.y) * i / n);
  }
  function cleared() {
    var data = ctx.getImageData(0, 0, W, H).data, step = 4 * 24, clear = 0, total = 0;
    for (var i = 3; i < data.length; i += step) { total++; if (data[i] < 40) clear++; }
    return clear / total;
  }
  function pt(e) { var r = foil.getBoundingClientRect(); return { x: e.clientX - r.left, y: e.clientY - r.top }; }
  if (foil) {
    foil.addEventListener('pointerdown', function (e) {
      if (!ctx) paintFoil();
      last = pt(e); if (foil.setPointerCapture) try { foil.setPointerCapture(e.pointerId); } catch (err) {}
      scratchAt(last.x, last.y);
    });
    foil.addEventListener('pointermove', function (e) { if (!last) return; var p = pt(e); line(last, p); last = p; });
    ['pointerup', 'pointercancel'].forEach(function (ev) {
      foil.addEventListener(ev, function () { last = null; if (ctx && !won && cleared() > .3) win(); });
    });
    foil.addEventListener('keydown', function (e) { if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); autoScratch(); } });
  }
  function autoScratch() {                                         // sweeps the foil off in three passes
    if (won) return; if (!ctx) paintFoil(); if (!ctx) return win();
    var r = foil.getBoundingClientRect(), w = r.width, h = r.height, rows = [.22, .5, .78], t0 = performance.now(), dur = reduceMotion ? 1 : 900;
    (function step(now) {
      var t = Math.min(1, (now - t0) / dur);
      rows.forEach(function (ry, k) { var p = Math.min(1, Math.max(0, t * 3 - k)); if (p > 0) scratchAt(w * (k % 2 ? 1 - p : p), h * ry); });
      if (t < 1 && !won) requestAnimationFrame(step); else win();
    })(t0);
  }
  autoBtn && autoBtn.addEventListener('click', function () { emit('auto'); autoScratch(); });

  function win() {
    if (won) return;
    won = true;
    if (foil) foil.classList.add('is-gone');
    burst();
    writeState({ won: Date.now() });
    emit('win');
    setTimeout(function () {
      setStep('won');
      if (live) live.textContent = live.getAttribute('data-pms-live-won') || '';
      // The scratch button just disappeared, so focus would fall to <body>: keep it in the dialog.
      if (root.open) { if (keyboardUser && claimEl) claimEl.focus(); else root.focus({ preventScroll: true }); }
    }, reduceMotion ? 0 : 420);
  }
  function burst() {
    if (reduceMotion || !coins) return;
    var h = '', cols = ['#ffffff', '#d9dde3', '#5a8fd0', '#24497a'];
    for (var i = 0; i < 26; i++) {
      var a = Math.random() * Math.PI * 2, d = 50 + Math.random() * 90, x = 160 + Math.cos(a) * d, y = 100 + Math.sin(a) * d * .6, c = cols[i % 4];
      h += '<rect x="157" y="97" width="7" height="4" rx="1" fill="' + c + '"><animate attributeName="x" from="157" to="' + x.toFixed(0) +
           '" dur=".75s" fill="freeze"/><animate attributeName="y" from="97" to="' + y.toFixed(0) + '" dur=".75s" fill="freeze"/>' +
           '<animate attributeName="opacity" from="1" to="0" begin=".4s" dur=".5s" fill="freeze"/></rect>';
    }
    coins.innerHTML = h;
  }

  /* ----------------------------------------------------------------- claim
     Decide inside the tap: by now Postscript's async SDK has long loaded, so if it
     is missing it is blocked. The fallback stays a native link tap so iOS can hand
     an sms: redirect to Messages. Postscript takes ~1 s to draw its pop-up, so the
     game stays up with "Pulling up form..." and steps aside the moment Postscript's
     frame is on screen (4 s at most). */
  function postscriptShowing() {
    var fs = document.querySelectorAll('iframe[src*="postscript.io"]'), vw = window.innerWidth, vh = window.innerHeight;
    for (var i = 0; i < fs.length; i++) {
      var r = fs[i].getBoundingClientRect();
      if (r.width > vw * 0.5 && r.height > vh * 0.5) return true;
    }
    return false;
  }
  function revealPostscript() { releaseHold(); root.close(); root.classList.remove('is-claiming'); }
  function handOverWhenShown() {
    root.classList.add('is-claiming');
    var t0 = Date.now();
    (function check() {
      if (!root.open) return;
      if (postscriptShowing() || Date.now() - t0 > 4000) return revealPostscript();
      requestAnimationFrame(check);
    })();
  }
  claimEl && claimEl.addEventListener('click', function (e) {
    if (root.classList.contains('is-claiming')) { e.preventDefault(); return; }
    var ps = window.postscript;
    // Postscript's phone field only lays out its +1 country code when it can focus itself as it opens, so open it fresh at
    // Claim, VISIBLE, with the page not inert: the game bridges as a non-modal overlay (z-index just below Postscript's
    // frame) until Postscript's frame covers it. Requires the Postscript trigger = Custom.
    if (cfg.popupId && ps && ps.popups && typeof ps.popups.open === 'function') {
      e.preventDefault();
      claimed = true; writeState({ claimed: Date.now() }); emit('claim', { via: 'postscript-popup' }); hideTab();
      releaseHold();
      root.classList.add('is-claiming');
      root.close(); root.show(); unlockScroll();                   // same dialog, now non-modal: the page (and Postscript) is not inert
      try { ps.popups.open(cfg.popupId, { activePopupBehavior: 'ALWAYS_DISMISS', respectPopupStatus: false }); } catch (err) {}
      handOverWhenShown();
      return;
    }
    if (!cfg.fallbackUrl) {                                         // nothing configured yet (QA via ?pm_scratch=1)
      e.preventDefault();
      var note = root.querySelector('[data-pms-setup-note]'); if (note) note.hidden = false;
      return;
    }
    // Postscript's script is blocked or missing: let the native link go to the fallback.
    claimed = true; writeState({ claimed: Date.now() }); emit('claim', { via: 'fallback-link' }); hideTab();
    releaseHold();
  });

  /* ------------------------------------------------- reopen tab (bottom left)
     After a dismiss, a small tab stays so the ticket can be found again:
     "Scratch for 10% off" before scratching, "Claim your 10% off" after. */
  var tab = document.querySelector('[data-pms-tab]');
  function tabWanted(s) {
    if (!tab || s.claimed || !s.dismissed || fromOurTexts()) return false;
    if (!ready && !cfg.force) return false;
    return !(s.tabHidden && Date.now() - s.tabHidden < cfg.cooldownDays * 864e5);
  }
  function showTab(checkSubscriber) {
    if (!tab || claimed || (!ready && !cfg.force)) return;
    tab.setAttribute('data-pms-won', (won || readState().won) ? 'true' : 'false');
    function show() { tab.hidden = false; tab._queueTuck && tab._queueTuck(); }
    if (!checkSubscriber) return show();
    isSubscriber(function (sub) { if (!sub) show(); });
  }
  function hideTab() { if (tab) tab.hidden = true; }
  if (tab) {
    tab.querySelector('[data-pms-tab-open]').addEventListener('click', function () { emit('tab-open'); if (!root.open) open(); });
    tab.querySelector('[data-pms-tab-close]').addEventListener('click', function () { writeState({ tabHidden: Date.now() }); hideTab(); emit('tab-hide'); });
    window.addEventListener('postscriptReady', function () { isSubscriber(function (sub) { if (sub) hideTab(); }); });
    // Never sit on a way to pay: tuck away while overlapping an add-to-bag, a sticky buy bar or the cart drawer.
    var BUY = 'form[action*="/cart/add"] button, form[action*="/cart/add"] [type="submit"], .shopify-payment-button, ' +
              'shopify-accelerated-checkout, .pm-buy, [class*="sticky"] button, [data-sticky-atc]';
    var tq = false;
    var overlaps = function (a, b) { return a.left < b.right && a.right > b.left && a.top < b.bottom && a.bottom > b.top; };
    var tuck = function () {
      tq = false; if (tab.hidden) return;
      var r = tab.getBoundingClientRect(); r = { left: r.left - 10, right: r.right + 10, top: r.top - 10, bottom: r.bottom + 10 };
      if (tab.classList.contains('is-tucked')) { var h = tab.offsetHeight + 24; r.top -= h; r.bottom -= h; }   // test where it rests
      var hit = !!document.querySelector('[data-pm-drawer][data-open="true"]'), els = document.querySelectorAll(BUY);
      for (var i = 0; i < els.length && !hit; i++) { var b = els[i].getBoundingClientRect(); if (b.width && b.height && overlaps(r, b)) hit = true; }
      tab.classList.toggle('is-tucked', hit);
    };
    var queueTuck = function () { if (!tq) { tq = true; requestAnimationFrame(tuck); } };
    window.addEventListener('scroll', queueTuck, { passive: true });
    window.addEventListener('resize', queueTuck);
    setInterval(function () { if (!tab.hidden) queueTuck(); }, 1500);   // the cart drawer opens without a scroll or resize
    tab._queueTuck = queueTuck;
  }

  // QA: ?pm_scratch=1 forces it open from a fresh start (even while switched off); PM_SCRATCH.reset() clears the visitor memory.
  window.PM_SCRATCH = {
    open: function () { if (!root.open) open(); },
    reset: function () { try { localStorage.removeItem(KEY); } catch (e) {} }
  };

  setStep('ready');
  arm();
})();
